import LiveChannelPage from './LiveChannelPage'

export default LiveChannelPage
// eslint-disable-next-line import/export
export * from './LiveChannelPage'
